export const OFFER_DECISION_FINNANCING_ASSETS_CHART_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Decision.OfferDecisionFinancingChartInvalidated";
